const map = {
	"./click-editar-dashboard.png": 86223,
	"./click-mis-dashboards.png": 98732,
	"./click-nuevo-dashboard.png": 26691,
	"./create-dashboard.png": 67971,
	"./select-dashboard.png": 47219
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3314;